<template>
	<router-view/>
</template>
<!-- https://www.npmjs.com/package/vue-head [ for twitter / discord preview ? ] -->
<script>
export default {
	name: 'app',
	beforeCreate() {
		// document.body.style.zoom = 1 / window.devicePixelRatio;
	}
};
</script>

<style lang="scss">
:root {
	--closed-side-panel-width: 30px;
	--lighter-blue: #52b7e9;
	--light-blue:   #189de4;
	--blue:         #146ca4;
	--dark-blue:		#203354;
	--darker-blue:  #242444;
	--gray-blue:    #484848;
}
html, body, #app {
	height: 100%;
	width: 100%;
	overflow: hidden;
}
body {
	margin: 0;
	font-size: 14px;
}
* {
	-webkit-tap-highlight-color: transparent;
	font-family: 'Share-TechMono', sans-serif;
	box-sizing: border-box;
	-moz-box-sizing: border-box;
	-webkit-box-sizing: border-box;
}
</style>
